import { HandlesBasketRequests } from "@shared/modules/basket/contracts";
import { TicketBasketType } from "@shared/modules/basket/types";
import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { UrlInjectionMap } from "@shared/services/api/types";

export default class PublicBasketRepository
  extends Repository<TicketBasketType>
  implements HandlesBasketRequests
{
  public readonly repositoryName = "PublicBasketRepository";

  public endpoint = "api/user/tickets/baskets";

  public get urlMap() {
    return {
      ...this.defaultUrlMap,
      expire: "{id}/expire",
    };
  }

  public async expire(
    id: number,
    config: ExtendedAxiosRequestConfig = {}
  ): Promise<void> {
    const injects: UrlInjectionMap = {
      [this.primaryKey]: id ?? this.injects[this.primaryKey],
    };

    await this.request(this.buildUrl("expire", injects), {
      method: "post",
      ...config,
    });
  }
}
